import { z } from 'zod';

const geoRegion = z.object({
    uri: z.literal('/geo/region'),
    neighbors: z.string().optional(),
    friendlyName: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoRegions = z.object({
    regions: z.array(geoRegion),
});
const geoCity = z.object({
    uri: z.literal('/geo/city'),
    istat: z.string(),
    regionId: z.string(),
    shortName: z.string(),
    friendlyName: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoTown = z.object({
    uri: z.literal('/geo/town'),
    istat: z.string(),
    regionId: z.string(),
    cityId: z.string(),
    hasZone: z.boolean(),
    friendlyName: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoZone = z.object({
    uri: z.literal('/geo/zone'),
    regionId: z.string(),
    cityId: z.string(),
    townId: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoZones = z.object({
    zones: z.array(geoZone),
});
const itemMap = z.object({
    zoom: z.string(),
    latitude: z.string(),
    longitude: z.string(),
    address: z.string().optional(),
    showPin: z.boolean().optional(),
});
const itemGeo = z.object({
    uri: z.literal('/geo'),
    type: z.string(),
    label: z.string(),
    region: geoRegion,
    city: geoCity.optional(),
    town: geoTown.optional(),
    zone: geoZone.optional(),
    map: itemMap.optional(),
});
z.object({
    zipCode: z.string(),
    town: z.string(),
    province: z.string(),
});
const geoEntry = z.object({
    region: geoRegion,
    city: geoCity.optional(),
    town: geoTown.optional(),
    zone: geoZone.optional(),
});
const geoEntries = z.object({
    entries: z.array(geoEntry).optional(),
});

z.string().length(9);
const itemURN = z.custom((val) => typeof val === 'string'
    ? /^id:ad:(.{36}|\d{8,9}):list:\d{8,9}$/.test(val)
    : false);
const price = z.number().int().min(0);
var MacroCategoryID;
(function (MacroCategoryID) {
    MacroCategoryID["Tutte"] = "0";
    MacroCategoryID["Motori"] = "1";
    MacroCategoryID["Immobili"] = "6";
    MacroCategoryID["LavoroServizi"] = "24";
    MacroCategoryID["Elettronica"] = "9";
    MacroCategoryID["CasaPersona"] = "13";
    MacroCategoryID["SportsHobby"] = "18";
    MacroCategoryID["Altri"] = "27";
})(MacroCategoryID || (MacroCategoryID = {}));
var LeafCategoryID;
(function (LeafCategoryID) {
    LeafCategoryID["Auto"] = "2";
    LeafCategoryID["AccessoriAuto"] = "5";
    LeafCategoryID["Moto"] = "3";
    LeafCategoryID["AccessoriMoto"] = "36";
    LeafCategoryID["Nautica"] = "22";
    LeafCategoryID["CaravanECamper"] = "34";
    LeafCategoryID["VeicoliCommerciali"] = "4";
    LeafCategoryID["Appartamenti"] = "7";
    LeafCategoryID["CamerePostiLetto"] = "43";
    LeafCategoryID["Ville"] = "29";
    LeafCategoryID["TerreniRustici"] = "30";
    LeafCategoryID["GarageBox"] = "31";
    LeafCategoryID["LoftMansarde"] = "32";
    LeafCategoryID["CaseVacanza"] = "33";
    LeafCategoryID["UfficiLocali"] = "8";
    LeafCategoryID["OfferteLavoro"] = "26";
    LeafCategoryID["Servizi"] = "50";
    LeafCategoryID["Candidati"] = "42";
    LeafCategoryID["Attrezzature"] = "25";
    LeafCategoryID["Informatica"] = "10";
    LeafCategoryID["ConsoleVideogiochi"] = "44";
    LeafCategoryID["AudioVideo"] = "11";
    LeafCategoryID["Fotografia"] = "40";
    LeafCategoryID["Telefonia"] = "12";
    LeafCategoryID["ArredamentoCasalinghi"] = "14";
    LeafCategoryID["Elettrodomestici"] = "37";
    LeafCategoryID["GiardinoFaiDaTe"] = "15";
    LeafCategoryID["AbbigliamentoAccessori"] = "16";
    LeafCategoryID["TuttoBambini"] = "17";
    LeafCategoryID["Animali"] = "23";
    LeafCategoryID["AccessoriAnimali"] = "100";
    LeafCategoryID["MusicaFilm"] = "19";
    LeafCategoryID["LibriRiviste"] = "38";
    LeafCategoryID["StrumentiMusicali"] = "39";
    LeafCategoryID["Sports"] = "20";
    LeafCategoryID["Biciclette"] = "41";
    LeafCategoryID["Collezionismo"] = "21";
    LeafCategoryID["AltriAnnunci"] = "28";
})(LeafCategoryID || (LeafCategoryID = {}));
const CategoryID = { ...MacroCategoryID, ...LeafCategoryID };
var AdTypes;
(function (AdTypes) {
    AdTypes["Sell"] = "s";
    AdTypes["Seek"] = "k";
    AdTypes["Rent"] = "u";
    AdTypes["VacationRent"] = "h";
    AdTypes["GiveAway"] = "g";
})(AdTypes || (AdTypes = {}));
const keyValuePair = z.object({
    key: z.string(),
    value: z.string(),
    weight: z.number().optional(),
    label: z.string().optional(),
    level: z.number().optional(),
    description: z.string().optional(),
});
const adTypeKeyValue = keyValuePair.merge(z.object({
    key: z.nativeEnum(AdTypes),
}));
var FeatureURI;
(function (FeatureURI) {
    FeatureURI["AdType"] = "/type";
    FeatureURI["AdvertiserType"] = "/advertiser_type";
    FeatureURI["AirConditioning"] = "/air_conditioning";
    FeatureURI["AllServicings"] = "/all_servicings";
    FeatureURI["AnimalType"] = "/animal_type";
    FeatureURI["AudiovideoType"] = "/audiovideo_type";
    FeatureURI["AvailableNow"] = "/available_now";
    FeatureURI["Balcony"] = "/balcony";
    FeatureURI["Bathrooms"] = "/bathrooms";
    FeatureURI["BicycleType"] = "/bicycle_type";
    FeatureURI["Bike"] = "/bike";
    FeatureURI["BookType"] = "/book_type";
    FeatureURI["Brand"] = "/brand";
    FeatureURI["BuildingCondition"] = "/building_condition";
    FeatureURI["Car"] = "/car";
    FeatureURI["CaravanType"] = "/caravan_type";
    FeatureURI["CarType"] = "/car_type";
    FeatureURI["Category"] = "/category";
    FeatureURI["CategoryFacet"] = "/category_facet";
    FeatureURI["ChildrenAge"] = "/children_age";
    FeatureURI["ChildrenType"] = "/children_type";
    FeatureURI["Cin"] = "/cin";
    FeatureURI["ClothingGender"] = "/clothing_gender";
    FeatureURI["ClothingNumber"] = "/clothing_number";
    FeatureURI["ClothingType"] = "/clothing_type";
    FeatureURI["Color"] = "/color";
    FeatureURI["ComputerType"] = "/computer_type";
    FeatureURI["Consumption"] = "/consumption";
    FeatureURI["ConsumptionSearchable"] = "/consumption_searchable";
    FeatureURI["ContractType"] = "/contract_type";
    FeatureURI["CubicCapacity"] = "/cubic_capacity";
    FeatureURI["Damaged"] = "/damaged";
    FeatureURI["Degree"] = "/degree";
    FeatureURI["Doors"] = "/doors";
    FeatureURI["DriveWheel"] = "/drive_wheel";
    FeatureURI["Elevator"] = "/elevator";
    FeatureURI["EnergyClass"] = "/energy_class";
    FeatureURI["EnginePower"] = "/engine_power";
    FeatureURI["Floor"] = "/floor";
    FeatureURI["Fuel"] = "/fuel";
    FeatureURI["Furnished"] = "/furnished";
    FeatureURI["Garden"] = "/garden";
    FeatureURI["Gearbox"] = "/gearbox";
    FeatureURI["Gender"] = "/gender";
    FeatureURI["Heating"] = "/heating";
    FeatureURI["HobbyType"] = "/hobby_type";
    FeatureURI["HorsePower"] = "/horsepower";
    FeatureURI["IsRental"] = "/is_rental";
    FeatureURI["ItemShippable"] = "/item_shippable";
    FeatureURI["ItemShippingCost"] = "/item_shipping_cost";
    FeatureURI["ItemShippingCostTuttoSubito"] = "/item_shipping_cost_tuttosubito";
    FeatureURI["ItemShippingPackageSize"] = "/item_shipping_package_size";
    FeatureURI["ItemShippingType"] = "/item_shipping_type";
    FeatureURI["ItemCondition"] = "/item_condition";
    FeatureURI["JobCategory"] = "/job_category";
    FeatureURI["LastFloor"] = "/last_floor";
    FeatureURI["Mileage"] = "/mileage";
    FeatureURI["MileageScalar"] = "/mileage_scalar";
    FeatureURI["Model"] = "/model";
    FeatureURI["MonthlyRent"] = "/monthly_rent";
    FeatureURI["MotorbicycleType"] = "/motorbicycle_type";
    FeatureURI["MultiLevel"] = "/multi_level";
    FeatureURI["Name"] = "/name";
    FeatureURI["NoSalesman"] = "/nosalesman";
    FeatureURI["OfficeType"] = "/office_type";
    FeatureURI["PaintType"] = "/paint_type";
    FeatureURI["Parking"] = "/parking";
    FeatureURI["PhoneType"] = "/phone_type";
    FeatureURI["Pollution"] = "/pollution";
    FeatureURI["Power"] = "/power";
    FeatureURI["Price"] = "/price";
    FeatureURI["Promotions"] = "/promotions";
    FeatureURI["QualitySeal"] = "/quality_seal";
    FeatureURI["QualitySealFlag"] = "/quality_seal_flag";
    FeatureURI["Reception"] = "/reception";
    FeatureURI["RegisterDate"] = "/register_date";
    FeatureURI["RegisterMonth"] = "/month";
    FeatureURI["RegMonth"] = "/regmonth";
    FeatureURI["Room"] = "/room";
    FeatureURI["Rooms"] = "/rooms";
    FeatureURI["RoomType"] = "/room_type";
    FeatureURI["Seats"] = "/seats";
    FeatureURI["Service"] = "/service";
    FeatureURI["ServiceType"] = "/service_type";
    FeatureURI["ShipLength"] = "/ship_length";
    FeatureURI["ShipType"] = "/ship_type";
    FeatureURI["Size"] = "/size";
    FeatureURI["SmokeFree"] = "/smoke_free";
    FeatureURI["Smoker"] = "/smoker";
    FeatureURI["ShippingCarriers"] = "/shipping_carriers";
    FeatureURI["SportType"] = "/sport_type";
    FeatureURI["TransactionStatus"] = "/transaction_status";
    FeatureURI["TotalOwners"] = "/total_owners";
    FeatureURI["UserId"] = "/user_id";
    FeatureURI["VatDeductible"] = "/vat_deductible";
    FeatureURI["VehicleLength"] = "/vehicle_length";
    FeatureURI["VehicleStatus"] = "/vehicle_status";
    FeatureURI["VehicleType"] = "/vehicle_type";
    FeatureURI["Version"] = "/version";
    FeatureURI["WarrantyMonths"] = "/warranty_months";
    FeatureURI["WorkHours"] = "/work_hour";
    FeatureURI["WorkLevel"] = "/work_level";
    FeatureURI["Year"] = "/year";
    FeatureURI["FashionClothingType"] = "/fashion/clothing_type";
    FeatureURI["FashionBrand"] = "/fashion/brand";
    FeatureURI["FashionSize"] = "/fashion/size";
})(FeatureURI || (FeatureURI = {}));
const itemFeature = z.object({
    uri: z.nativeEnum(FeatureURI),
    type: z.string(),
    label: z.string(),
    values: z.array(keyValuePair),
});
const itemImage = z.object({
    cdnBaseUrl: z.string(),
});
const itemCategory = z.object({
    id: z.nativeEnum(LeafCategoryID),
    label: z.string(),
    parentId: z.nativeEnum(MacroCategoryID),
    friendlyName: z.string(),
    weight: z.number(),
});
const itemFeatures = z.record(z.nativeEnum(FeatureURI), itemFeature);
const itemVisibilityOptions = z.object({
    gallery: z.boolean(),
    urgent: z.boolean(),
    smartbumpedAt: z.string().optional(),
});
var AdvertiserType;
(function (AdvertiserType) {
    AdvertiserType[AdvertiserType["Private"] = 0] = "Private";
    AdvertiserType[AdvertiserType["Pro"] = 1] = "Pro";
    AdvertiserType[AdvertiserType["Company"] = 2] = "Company";
})(AdvertiserType || (AdvertiserType = {}));
const itemAdvertiser = z.object({
    company: z.boolean(),
    name: z.string(),
    phone: z.string().optional(),
    type: z.nativeEnum(AdvertiserType),
    userId: z.string(),
    shopId: z.string().optional(),
    shopName: z.string().optional(),
    proTransactionsEnabled: z.boolean().optional(),
});
const adItem = z.object({
    kind: z.literal('AdItem'),
    urn: itemURN,
    type: adTypeKeyValue,
    category: itemCategory,
    subject: z.string(),
    body: z.string(),
    date: z.string(),
    images: z.array(itemImage),
    features: itemFeatures,
    advertiser: itemAdvertiser,
    geo: itemGeo,
    urls: z.object({ default: z.string(), mobile: z.string() }),
    gallerized: z.boolean().optional(),
    visibilityOptions: itemVisibilityOptions.optional(),
});
const adOwnerVerification = z.object({
    userID: z.string().optional(),
    listID: z.string().optional(),
    isOwner: z.boolean().optional(),
});
const correlatedTrackingInfo = z.object({
    transactionID: z.string(),
    listName: z.string(),
    itemID: z.string(),
});
const correlatedAdsIds = z.object({
    ids: z.array(itemURN),
    trackingInfo: correlatedTrackingInfo.optional(),
});
const userAdStatistics = z.object({
    position: z.number(),
    messages: z.number(),
    views: z.number(),
});
const userAd = adItem.merge(z.object({
    editUrl: z.string().optional(),
    expiresIn: z.number().optional(),
    statistics: userAdStatistics.optional(),
    paidOptions: z.array(z.object({ id: z.string() })).optional(),
}));
const searchExtras = z.object({
    advertiserTypeFacets: z.record(z.string(), z.string()).optional(),
});
const userAds = z.object({
    total: z.number(),
    checkNew: z.string(),
    lines: z.number(),
    start: z.number(),
    extras: searchExtras.optional(),
    filterLabels: z.record(z.string(), z.string()).optional(),
    ads: z.array(userAd),
});

var SearchParam;
(function (SearchParam) {
    /** The advertiser userid of the currently displayed item, to search recommendations */
    SearchParam["UserID"] = "uid";
    /** The ad type */
    SearchParam["AdType"] = "t";
    /** The query: the text to search for. */
    SearchParam["Query"] = "q";
    /** Whether to search only in the title of the ad or also in the body. */
    SearchParam["QuerySubjectOnly"] = "qso";
    /** The ID of the category to search in, stringified. */
    SearchParam["Category"] = "c";
    /** The Advertiser Type */
    SearchParam["AdvertiserType"] = "advt";
    /** The Item condition */
    SearchParam["ItemCondition"] = "ic";
    /** The ID of the geo region to search in */
    SearchParam["GeoRegion"] = "r";
    /** The ID of the geo city to search in */
    SearchParam["GeoCity"] = "ci";
    /** The ID of the geo town to search in */
    SearchParam["GeoTown"] = "to";
    /** The ID of the geo zone to search in */
    SearchParam["GeoZone"] = "z";
    /** The ListID of the items to search, it's a comma separated list of IDs. */
    SearchParam["ListIDs"] = "list_ids";
    /** Pagination: The maximum number of ads to return per page */
    SearchParam["PageSize"] = "lim";
    /** Pagination: The current page number, first page is 0 */
    SearchParam["PageStart"] = "start";
    /** The Sorting order */
    SearchParam["SortingOrder"] = "sort";
    /** RadiusSearch: The latitude of the central point */
    SearchParam["Latitude"] = "lat";
    /** RadiusSearch: The longitude of the central point */
    SearchParam["Longitude"] = "lon";
    /** RadiusSearch: The radius of the search from the central point */
    SearchParam["Radius"] = "rad";
    /** Include only shippable results */
    SearchParam["ItemShippable"] = "shp";
    /** Include only urgent results */
    SearchParam["ItemUrgent"] = "urg";
    /** Market Personal Computer type */
    SearchParam["MarketComputerType"] = "pt";
    /** Market AudioVideo type */
    SearchParam["MarketAudioVideoType"] = "avt";
    /** Market Phone type */
    SearchParam["MarketPhoneType"] = "pht";
    /** Market clothing type */
    SearchParam["MarketClothingType"] = "clt";
    /** Market clothing brand */
    SearchParam["MarketClothingBrand"] = "fbrnd";
    /** Market clothing size */
    SearchParam["MarketClothingSize"] = "fsz";
    /** Market clothing gender */
    SearchParam["MarketClothingGender"] = "clg";
    /** Market children clothing type */
    SearchParam["MarketChildrenType"] = "cht";
    /** Market children clothing age */
    SearchParam["MarketChildrenAge"] = "cha";
    /** Market animal species */
    SearchParam["MarketAnimalSpecies"] = "at";
    /** Market book type */
    SearchParam["MarketBookType"] = "bot";
    /** Market sport type */
    SearchParam["MarketSportType"] = "st";
    /** Market bicycle type */
    SearchParam["MarketBycicleType"] = "bkt";
    /** Market hobby type */
    SearchParam["MarketHobbyType"] = "ht";
    /** Car Vehicle Status */
    SearchParam["CarVehicleStatus"] = "cvs";
    /** Car brand */
    SearchParam["CarBrand"] = "cb";
    /** Car model */
    SearchParam["CarModel"] = "cm";
    /** Car model in recommendation search apparently has a different query param */
    SearchParam["CarModelReccomendation"] = "cmo";
    /** Car quality seal */
    SearchParam["CarQualitySeal"] = "qltsf";
    /** Car registration year from */
    SearchParam["CarYearMin"] = "ys";
    /** Car registration year to */
    SearchParam["CarYearMax"] = "ye";
    /** Price min */
    SearchParam["PriceMin"] = "ps";
    /** Price max */
    SearchParam["PriceMax"] = "pe";
    /** Car mileage min */
    SearchParam["CarMileageMin"] = "ms";
    /** Car mileage max */
    SearchParam["CarMileageMax"] = "me";
    /** Car type */
    SearchParam["CarType"] = "ct";
    /** Car fuel */
    SearchParam["CarFuel"] = "fl";
    /** Car gear */
    SearchParam["CarGear"] = "gr";
    /** Car seats min */
    SearchParam["CarSeatsMin"] = "ss";
    /** Car seats max */
    SearchParam["CarSeatsMax"] = "se";
    /** Cat doors */
    SearchParam["CarDoors"] = "dr";
    /** Car Color */
    SearchParam["CarColor"] = "cl";
    /** Car emissions class */
    SearchParam["CarPollution"] = "pl";
    /** VAT is deductible */
    SearchParam["CarVATDeductible"] = "vatd";
    /** Motorcycle brand */
    SearchParam["BikeBrand"] = "bb";
    /** Motorcycle model */
    SearchParam["BikeModel"] = "bm";
    /** Motorcycle type */
    SearchParam["BikeType"] = "mt";
    /** Motorcycle Cubic Capacity min */
    SearchParam["BikeCapacityMin"] = "ccs";
    /** Motorcycle Cubic Capacity max */
    SearchParam["BikeCapacityMax"] = "cce";
    /** Ship type */
    SearchParam["ShipType"] = "bt";
    /** Ship length min */
    SearchParam["ShipLengthMin"] = "lns";
    /** Ship length max */
    SearchParam["ShipLengthMax"] = "lne";
    /** Caravan type */
    SearchParam["CaravanType"] = "crt";
    /** Commercial Vehicle type */
    SearchParam["CommercialVehicleType"] = "cvt";
    /** RealEstate surface min */
    SearchParam["RealEstateSurfaceMin"] = "szs";
    /** RealEstate surface max */
    SearchParam["RealEstateSurfaceMax"] = "sze";
    /** RealEstate conditions */
    SearchParam["RealEstateCondition"] = "bc";
    /** RealEstate room min */
    SearchParam["RealEstateRoomMin"] = "rs";
    /** RealEstate room max */
    SearchParam["RealEstateRoomMax"] = "re";
    /** RealEstate available now */
    SearchParam["RealEstateAvailableNow"] = "an";
    /** RealEstate floor min */
    SearchParam["RealEstateFloorMin"] = "fls";
    /** RealEstate floor max */
    SearchParam["RealEstateFloorMax"] = "fle";
    /** RealEstate Bathrooms min number */
    SearchParam["RealEstateBathroomMinNumber"] = "btrs";
    /** RealEstate Bathrooms max number */
    SearchParam["RealEstateBathroomMaxNumber"] = "btre";
    /** RealEstate has balcony */
    SearchParam["RealEstateBalcony"] = "blc";
    /** RealEstate has elevator */
    SearchParam["RealEstateElevator"] = "el";
    /** RealEstate is last floor */
    SearchParam["RealEstateLastFloor"] = "lflr";
    /** RealEstate has parking */
    SearchParam["RealEstateParking"] = "prk";
    /** RealEstate has heating */
    SearchParam["RealEstateHeating"] = "htg";
    /** RealEstate has air conditioning */
    SearchParam["RealEstateConditioning"] = "ac";
    /** RealEstate energy class min */
    SearchParam["RealEstateEnergyClassMin"] = "ecs";
    /** RealEstate energy class max */
    SearchParam["RealEstateEnergyClassMax"] = "ece";
    /** RealEstate is furnished */
    SearchParam["RealEstateFurnished"] = "fr";
    /** RealEstate room type */
    SearchParam["RealEstateRoomType"] = "rt";
    /** RealEstate room gender */
    SearchParam["RealEstateRoomGender"] = "gndr";
    /** RealEstate smokers allowed */
    SearchParam["RealEstateSmokers"] = "smk";
    /** RealEstate is multi-level */
    SearchParam["RealEstateMultiLevel"] = "mlv";
    /** RealEstate has garden */
    SearchParam["RealEstateGarden"] = "grd";
    /** RealEstate office type */
    SearchParam["RealEstateOfficeType"] = "ot";
    /** RealEstate can be seen with virtual tour */
    SearchParam["RealEstateVirtualTour"] = "vt";
    /** Jobs category */
    SearchParam["JobsCategory"] = "jc";
    /** Jobs contract type */
    SearchParam["JobsContractType"] = "cnt";
    /** Jobs work hours */
    SearchParam["JobsWorkHours"] = "wh";
    /** Jobs work level */
    SearchParam["JobsWorkLevel"] = "wl";
    /** Jobs degree */
    SearchParam["JobsDegree"] = "d";
    /** Jobs service type */
    SearchParam["JobsServiceType"] = "set";
    /** Jobs service name */
    SearchParam["JobsServiceName"] = "sen";
})(SearchParam || (SearchParam = {}));
const searchParam = z.enum(Object.values(SearchParam));
var FilterURI;
(function (FilterURI) {
    FilterURI["AdType"] = "/type";
    FilterURI["Query"] = "/query/search_text";
    FilterURI["QuerySubjectOnly"] = "/query/subject_only";
    FilterURI["Category"] = "/category";
    FilterURI["AdvertiserType"] = "/advertiser_type";
    FilterURI["ItemCondition"] = "/item_condition";
    FilterURI["Geo"] = "/geo";
    FilterURI["GeoRegion"] = "/geo/region";
    FilterURI["GeoCity"] = "/geo/city";
    FilterURI["GeoTown"] = "/geo/town";
    FilterURI["GeoZone"] = "/geo/zone";
    FilterURI["Region"] = "/region";
    FilterURI["Page"] = "/page";
    FilterURI["Order"] = "/order";
    FilterURI["ItemShippable"] = "/item_shippable";
    FilterURI["ItemUrgent"] = "/urgent";
    FilterURI["Latitude"] = "/radius/latitude";
    FilterURI["Longitude"] = "/radius/longitude";
    FilterURI["Radius"] = "/radius/distance";
    FilterURI["MarketComputerType"] = "/computer_type";
    FilterURI["MarketAudioVideoType"] = "/audiovideo_type";
    FilterURI["MarketPhoneType"] = "/phone_type";
    FilterURI["MarketClothingType"] = "/fashion/clothing_type";
    FilterURI["MarketClothingBrand"] = "/fashion/brand";
    FilterURI["MarketClothingSize"] = "/fashion/size";
    FilterURI["MarketClothingGender"] = "/clothing_gender";
    FilterURI["MarketChildrenType"] = "/children_type";
    FilterURI["MarketChildrenAge"] = "/children_age";
    FilterURI["MarketAnimalSpecies"] = "/animal_type";
    FilterURI["MarketBookType"] = "/book_type";
    FilterURI["MarketSportType"] = "/sport_type";
    FilterURI["MarketBycicleType"] = "/bicycle_type";
    FilterURI["MarketHobbyType"] = "/hobby_type";
    FilterURI["CarVehicleStatus"] = "/vehicle_status";
    FilterURI["CarBrand"] = "/car/brand";
    FilterURI["CarModel"] = "/car/model";
    FilterURI["CarQualitySeal"] = "/quality_seal";
    FilterURI["QualitySealFlag"] = "/quality_seal_flag";
    FilterURI["CarYear"] = "/year";
    FilterURI["CarYearMin"] = "/year/min";
    FilterURI["CarYearMax"] = "/year/max";
    FilterURI["CarMonth"] = "/month";
    FilterURI["Price"] = "/price";
    FilterURI["PriceMin"] = "/price/min";
    FilterURI["PriceMax"] = "/price/max";
    FilterURI["CarMileage"] = "/mileage";
    FilterURI["CarMileageMin"] = "/mileage/min";
    FilterURI["CarMileageMax"] = "/mileage/max";
    FilterURI["CarType"] = "/car_type";
    FilterURI["CarFuel"] = "/fuel";
    FilterURI["CarGear"] = "/gearbox";
    FilterURI["CarSeats"] = "/seats";
    FilterURI["CarSeatsMin"] = "/seats/min";
    FilterURI["CarSeatsMax"] = "/seats/max";
    FilterURI["CarDoors"] = "/doors";
    FilterURI["CarColor"] = "/color";
    FilterURI["CarPollution"] = "/pollution";
    FilterURI["CarVATDeductible"] = "/vat_deductible";
    FilterURI["BikeBrand"] = "/bike/brand";
    FilterURI["BikeModel"] = "/bike/model";
    FilterURI["BikeType"] = "/motorbicycle_type";
    FilterURI["BikeCapacity"] = "/cubic_capacity";
    FilterURI["BikeCapacityMin"] = "/cubic_capacity/min";
    FilterURI["BikeCapacityMax"] = "/cubic_capacity/max";
    FilterURI["ShipType"] = "/ship_type";
    FilterURI["ShipLength"] = "/ship_length";
    FilterURI["ShipLengthMin"] = "/ship_length/min";
    FilterURI["ShipLengthMax"] = "/ship_length/max";
    FilterURI["CaravanType"] = "/caravan_type";
    FilterURI["CommercialVehicleType"] = "/vehicle_type";
    FilterURI["RealEstateSurface"] = "/size";
    FilterURI["RealEstateSurfaceMin"] = "/size/min";
    FilterURI["RealEstateSurfaceMax"] = "/size/max";
    FilterURI["RealEstateCondition"] = "/building_condition";
    FilterURI["RealEstateRoom"] = "/room";
    FilterURI["RealEstateRoomMin"] = "/room/min";
    FilterURI["RealEstateRoomMax"] = "/room/max";
    FilterURI["RealEstateAvailableNow"] = "/available_now";
    FilterURI["RealEstateFloor"] = "/floor";
    FilterURI["RealEstateFloorMin"] = "/floor/min";
    FilterURI["RealEstateFloorMax"] = "/floor/max";
    FilterURI["RealEstateBathroomNumber"] = "/bathrooms";
    FilterURI["RealEstateBathroomMinNumber"] = "/bathrooms/min";
    FilterURI["RealEstateBathroomMaxNumber"] = "/bathrooms/max";
    FilterURI["RealEstateBalcony"] = "/balcony";
    FilterURI["RealEstateElevator"] = "/elevator";
    FilterURI["RealEstateLastFloor"] = "/last_floor";
    FilterURI["RealEstateParking"] = "/parking";
    FilterURI["RealEstateHeating"] = "/heating";
    FilterURI["RealEstateConditioning"] = "/air_conditioning";
    FilterURI["RealEstateEnergyClass"] = "/energy_class";
    FilterURI["RealEstateEnergyClassMin"] = "/energy_class/min";
    FilterURI["RealEstateEnergyClassMax"] = "/energy_class/max";
    FilterURI["RealEstateFurnished"] = "/furnished";
    FilterURI["RealEstateRoomType"] = "/room_type";
    FilterURI["RealEstateRoomGender"] = "/gender";
    FilterURI["RealEstateSmokers"] = "/smoker";
    FilterURI["RealEstateMultiLevel"] = "/multi_level";
    FilterURI["RealEstateGarden"] = "/garden";
    FilterURI["RealEstateOfficeType"] = "/office_type";
    FilterURI["RealEstateVirtualTour"] = "/virtual_tour";
    FilterURI["JobsCategory"] = "/job_category";
    FilterURI["JobsContractType"] = "/contract_type";
    FilterURI["JobsWorkHours"] = "/work_hour";
    FilterURI["JobsWorkLevel"] = "/work_level";
    FilterURI["JobsDegree"] = "/degree";
    FilterURI["JobsServiceType"] = "/service/type";
    FilterURI["JobsServiceName"] = "/service/name";
})(FilterURI || (FilterURI = {}));
const filterURI = z.enum(Object.values(FilterURI));
const filterMetadata = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.undefined(),
]);
const filterValue = z.object({
    key: z.string(),
    label: z.string().optional(),
    metadata: z.record(z.string(), filterMetadata).optional(),
});
const filterWithValues = z.object({
    uri: filterURI,
    values: z.array(filterValue),
    label: z.string().optional(),
});
z.record(searchParam, z.union([z.string(), z.number(), z.boolean()]));
const searchResult = z.object({
    total: z.number(),
    lines: z.number(),
    start: z.number(),
    checkNew: z.string().optional(),
    ads: z.array(adItem),
    filterLabels: z.record(searchParam, z.string()).optional(),
});
const searchRecommendedResult = z.object({
    count: z.number(),
    filters: filterWithValues.array(),
});
const searchOrders = z.enum([
    'relevance',
    'datedesc',
    'priceasc',
    'pricedesc',
    'yearasc',
    'yeardesc',
    'mileageasc',
    'mileagedesc',
]);
const filterValues = z.object({
    values: z.array(keyValuePair).optional(),
    topValues: z.array(keyValuePair).nullable().optional(),
});
const savedSearchBase = z.object({
    filters: z.array(filterWithValues),
    sort: searchOrders,
});
const savedSearch = savedSearchBase.extend({
    searchId: z.string(),
    insertionDate: z.string(),
    updateDate: z.string(),
    premiumExpirationDate: z.string().nullable(),
});
const savedSearches = z.object({
    savedSearches: z.array(savedSearch),
});
const baseFilter = z.object({
    uri: filterURI,
    label: z.string(),
});
const specialFilter = baseFilter.extend({
    type: z.enum(['category', 'adtype']),
    queryString: z.string(),
    dataSource: z.string(),
});
const listFilter = baseFilter.extend({
    type: z.literal('list'),
    queryString: z.string(),
    dataSource: z.string(),
    multiSelection: z.boolean().optional(),
    searchable: z.boolean().optional(),
    dependencies: z.array(filterURI).optional(),
});
const boolFilter = baseFilter.extend({
    type: z.literal('bool'),
    queryString: z.string(),
    subLabel: z.string().optional(),
});
const rangeFilter = baseFilter.extend({
    type: z.literal('range'),
    min: listFilter,
    max: listFilter,
});
const serializableFilter = z.union([
    listFilter,
    boolFilter,
    specialFilter,
]);
const compositeFilter = z.union([serializableFilter, rangeFilter]);
const filterConfig = z.object({
    filters: compositeFilter.array(),
});

class NetError extends Error {
    name;
    message;
    cause;
    constructor(message, cause) {
        super();
        this.name = 'NetError';
        this.message = message;
        this.cause = cause;
    }
}

const postcode = z.string().length(5);
const state = z.string().length(2);
const userAddress = z.object({
    address: z.string(),
    addressLine2: z.string(),
    id: z.string(),
    name: z.string(),
    surname: z.string(),
    number: z.string(),
    postcode,
    province: z.string(),
    state,
    town: z.string(),
    phone: z.string(),
});
userAddress.extend({
    valid: z.boolean(),
});

var PackageSize;
(function (PackageSize) {
    PackageSize["small"] = "10";
    PackageSize["medium"] = "20";
    PackageSize["big"] = "30";
    PackageSize["maxi"] = "40";
})(PackageSize || (PackageSize = {}));
const destinationType = z.enum(['user_address', 'service_point']);
const carrierID = z.enum([
    'poste_italiane',
    'ups',
    'bartolini',
    'inpost',
]);
const carrierName = z.enum(['Poste Italiane', 'UPS', 'BRT', 'InPost']);
const carrierShortName = z.enum(['Poste', 'UPS', 'BRT', 'InPost']);
const shippingRate = z.object({
    optionID: z.nativeEnum(PackageSize),
    carrierID,
    carrierName,
    carrierShortName,
    destinationType,
    total: z.number(),
    strikethroughTotal: z.number().optional(),
});
const shippingRates = z.object({
    rates: z.array(shippingRate),
});
const servicePointRecap = z.object({
    servicePointID: z.string(),
    name: z.string(),
    address: z.string(),
    town: z.string(),
    postcode,
    countryCode: z.enum(['IT', 'ITA']),
    carrierID,
    carrierName,
});

export { AdvertiserType as A, CategoryID as C, FeatureURI as F, LeafCategoryID as L, MacroCategoryID as M, NetError as N, PackageSize as P, SearchParam as S, searchRecommendedResult as a, filterConfig as b, geoZones as c, geoEntries as d, savedSearch as e, filterValues as f, geoRegions as g, savedSearches as h, correlatedAdsIds as i, shippingRates as j, adItem as k, adOwnerVerification as l, geoEntry as m, itemURN as n, carrierID as o, price as p, servicePointRecap as q, destinationType as r, searchResult as s, userAddress as t, userAds as u, AdTypes as v, FilterURI as w };
//# sourceMappingURL=zod-DfBqeaiX.js.map
